module.exports = __webpack_public_path__ + "media/flags/aq-4fc98efb.svg";